import React from 'react';

import './Eingabe.css';

class EingabeZusatzoptionen extends React.Component {
    render() {
        return (
            <div>
                <input key={this.props.id} onClick={this.props.handleCheckChieldElement} type="checkbox" id={this.props.id} checked={this.props.isChecked} value={this.props.value} /> {this.props.value}
            </div>
        );
    }
}
export default EingabeZusatzoptionen;